import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { BREAK_POINTS } from '../../../../constants/common/breakpoints';

const StyledSidebarContainer = styled.div<React.ComponentPropsWithRef<'div'>>`
    border-radius: 6px;
    padding-top:45px;
    display: flex;
    flex-direction: column;
    border: none;
    .gi-sidebar_nav_list {
        background: ${({ theme }) => theme.defaultWhite};
        font-weight: 400;
    }
    @media (max-width: ${BREAK_POINTS.sm}) {
        width: 100%;
    }
    .theme-bg {
        padding:10px;
        background-color: ${({ theme }) => theme.infoLightest} !important;
    }
`;

const SidebarTop = (props) => {
    const { totalRXCUI } = props;
    return (
        <StyledSidebarContainer className='manage-drugs-side-nav' data-testid="manage-drugs-side-nav-conatainer">
            <h1 className="pull-left" data-testid="manage-drugs-header">
                <FormattedMessage id="pgheader.manageDrugs" />
            </h1>
            <small data-testid="manage-drugs-count"> {totalRXCUI}{' '}
                <FormattedMessage id="manage.drugs.total.rxcui" />
            </small>
        </StyledSidebarContainer>
    );
};

export default SidebarTop;
